import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		mineInfo: null,
		loginStatus: false,
		wxUserStatus:false,
		loginModalStatus: {
			display: false,
			type: 'login'
		},
		locationCity: [],	// 地区选择
		placeData: [],		// 地区表
		notifData: {}, 		// 当前推送来的通知
		singlechat: {},		// 当前一条私信
		serverBagInfo: {}, // 服务包信息
		curcontactinfo: {},     // 当前聊天对象基本信息 id name
		currentSide: '',
		schedureId: null, 
		bindPhoneDialog: false, // 绑定手机弹出层
		honsenAllTree: [], // honsen 模块所有功能
		honsenOwnAuthority: [], // honsen 自己所有权限
		honsenBtnOwnAuthority: [], // 自己的权限 btn
		consultChat:{},  //咨询消息
		consultNum:{},  //咨询未读数
		OutsideloginStatus:{
			display:false,
			type:0
		}  //控制咨询授权框,type=0为没有登录成功，1位登录成功

	},
	getters: {

	},
	mutations: {
		clearalldata(state) {
			state.mineInfo = null;
			state.loginStatus = false;
			state.wxUserStatus = false;
			state.loginModalStatus = {
				display: false,
				type: 'login'
			};
			state.notifData = {}; 			// 当前推送来的通知
			state.singlechat = {};			// 当前一条私信
			state.serverBagInfo = {};		// 清空服务包信息
			state.consultChat = {};
			state.OutsideloginStatus = {
				display: false ,
				type:0
			};  //控制咨询授权框
		},
		//是否为微信扫码登录用户
		changeWxUser(state,status){
			state.wxUserStatus = status;
		},
		// 控制mineInfo
		changeMineInfo(state, obj) {
			state.mineInfo = state.mineInfo ? {...state.mineInfo, ...obj} : obj;
		},
		// 改变地区选择
		changeLocationCity(state, arr) {
			state.locationCity = arr;
		},
		// 改变地区选择
		changePlaceData(state, arr) {
			state.placeData = arr;
		},
		// 控制登录框
		changeLoginModalStatus(state, obj) {
			state.loginModalStatus = { ...state.loginModalStatus, ...obj};
		},
		changeloginStatus(state, status) {
			state.loginStatus = status;
		},
		// 推送来的通知消息
		addNotiData(state, data) {
			state.notifData = data;
		},
		// 推送来的私信
		changeSinglechat(state, data) {
			state.singlechat = data;
		},
		// 推送来的日程
		addSchedure(state, data) {
			state.schedureId = data;
		},
		// 私信已读
		changeChatRead(state, data) {
			state.chatread = data;
		},
		// 储存当前选择服务包信息
		getserverBagInfo(state, data) {
			state.serverBagInfo = data
		},
		clearHaveCompany(state, data) {
			state.mineInfo.have_company = data
		},
		// 改变当前聊天对象
		changeCurcontactInfo(state, data) {
			state.curcontactinfo = data;
		},
		/* 侧边栏的显示 */
		setSide(state, name) {
			state.currentSide = state.currentSide == name?'': name;
		},
		showSchPanel(state) {
            state.currentSide = 'schedule';
		},
		addSchedure(state,data) {
            state.schedureId = data;
		},
		// 改变绑定弹出层状态
		changebindPhone(state, data) {
			state.bindPhoneDialog = data
		},
		// honsenTree
		pushHonsenAllTree(status, data) {
			status.honsenAllTree = data
		},
		// honsen个人权限
		pushHonsenOwnAuthority(status, data) {
			status.honsenOwnAuthority = data
		},

		pushHonsenBtnOwnAuthority(status, data) {
			status.honsenBtnOwnAuthority = data
		},
		//推送来的咨询
		changeConsult(status, data){
			status.consultChat = data
		},
		//控制咨询授权框
		changeOutsideLoginStatus(state, obj) {
			state.OutsideloginStatus = { ...state.OutsideloginStatus, ...obj};
		},
		//咨询未读数
		changeConsultNum(status,data){
			status.consultNum = data
		}
	}
});


// WEBPACK FOOTER //
// ./src/vueX/index.js